import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getPublicMapLink } from "../../../../../../../services/GlobalRoles/getPublicMapLink";
import { useParams } from "react-router-dom";
import { useWebsite } from "../../../Context/WebSiteContext";

export default function MapClassic({ config, enterprise_id}) {
  const [linkMap, setLinkMap] = useState("");

  async function getMapLink() {
    const sendData = {
      empId: enterprise_id,
      typeMap: "map",
      };
      const protocol = window.location.protocol;
      const baseUrl = window.location.host;
  
      console.log(protocol + baseUrl);
      const res = await getPublicMapLink(sendData);
      setLinkMap(`${protocol}//${baseUrl}/publicMap/${res.success}`);
    }

  // const iframeUrl =
  //   "https://hrtincorporadora.incorpmobile.tec.br/mapa_telao.php?empreendimento_id=1";

  useEffect(() => {
    getMapLink();
  }, []);

  return (
    <section
      key="map"
      id="map"
      className=""
      style={{
        backgroundColor: `#${config.primaryColor || "262628"}`,
        padding: 0,
        margin: 0,
        width: "100%",
        height: "100vh", // ocupa 100% da altura da tela
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        fontFamily: "Axiforma, sans-serif",
      }}
    >
      {/* Título e subtítulo */}
      <div className="px-3 py-5 text-center"
        style={{
          color: `#${config.secondaryColor || "262628"}`,
        }}
      >
        <h2 style={{ margin: 0, fontSize: "2.5rem" }}>Mapa Interativo</h2>
        <p style={{ margin: "5px 0 0", fontSize: "1rem", opacity: 0.8 }}>
          acompanhe em tempo real as vendas do empreendimento!
        </p>
      </div>

      {/* Mapa */}
      <div
        style={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          height: "100%",
        }}
      >
        <iframe
          src={linkMap}
          title="Status da Obra"
          style={{
            border: "none",
            width: "80vw",
            height: "80vh",
            maxWidth: "100%",
            height: "80%",
            boxShadow: "0 2px 16px rgba(0,0,0,0.15)",
            borderRadius: "12px",
          }}
        />
      </div>
    </section>
  );
}
